import * as React from 'react'

import AdbIcon from '@mui/icons-material/Adb'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { useHistory } from 'react-router-dom'

const pages = ['Products', 'Pricing', 'Contact']

function ResponsiveAppBar() {
  const history = useHistory()

  const handleRedirectPage = () => {
    history.push(`/contact`)
  }

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#fff',
        boxShadow: '0px 8px 8px 0px #00000008',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <AdbIcon
            sx={{
              display: { xs: 'none', md: 'flex' },
              mr: 1,
              backgroundColor: '#0050AE',
            }}
          />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: '#0050AE',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleRedirectPage}
                sx={{ my: 2, color: '#0050AE', display: 'block', fontSize: 16 }}
                variant="text"
              >
                {page}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Button
              onClick={() => history.push('/login')}
              sx={{ my: 2, display: 'block', fontSize: 16 }}
              variant="text"
            >
              Login
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
export default ResponsiveAppBar
